import React from 'react';
import DocumentMeta from 'react-document-meta';
import Container from 'react-bootstrap/Container';
import Navigation from '../composants/commun/navigation';
import { useState } from 'react';
import PiedPage from '../composants/commun/pied-page';
import TitrePage from '../composants/commun/titre-page';
import VideoBiographie from '../composants/biographie/video-biographie';
import TexteBiographie from '../composants/biographie/texte-biographie';
import { obtenirMeta } from '../utilitaires/utilMeta';

export default function PageBiographie() {
    const meta = obtenirMeta(window.location)
    const [state]  = useState({
      meta: meta
    });
    return (
        <DocumentMeta {...state.meta}>
        <Container fluid>
          <Navigation></Navigation>
          <TitrePage titre="Biographie"></TitrePage>
          <VideoBiographie></VideoBiographie>
          <TexteBiographie></TexteBiographie>
          <PiedPage></PiedPage>
        </Container>
      </DocumentMeta>
    );
  }